import Vue from 'vue'
import commonMutations from '@/store/data/common/mutations'
import { filter, find, findIndex, toNumber, includes, isEmpty } from 'lodash'

const mutations = {
    setAccountCountryData(state, { items }) {
        Vue.set(state, 'country', items)
    },

    setAccountId(state, { id }) {
        Vue.set(state, 'accountId', id)
    },

    setIsAccountAllowed(state, { allowed }) {
        Vue.set(state, 'isAccountAllowed', allowed)
    },

    setAccountIsActive(state, value) {
        Vue.set(state, 'isActive', value)
    },

    setProductAccountIsActive(state, value) {
        Vue.set(state, 'productAccountIsActive', value)
    },

    setAccountLabel(state, { label }) {
        Vue.set(state, 'label', label)
    },

    setAccountLinkedAccountsDetails(state, { linkedAccounts }) {
        if (linkedAccounts.adperf) {
            Vue.set(state, 'linkedAccounts', {
                wcm: {
                    accountId: toNumber(linkedAccounts.adperf[0].id),
                    isActive: !!linkedAccounts.adperf[0].is_active
                }
            })
        }
    },

    setAccountIsRuleActivated(state, isActivated) {
        Vue.set(state.settings, 'ruleActivated', isActivated === 'YES')
    },

    setAccountIsBootstrapCustomSegmentAvailable(state, { isActivated }) {
        Vue.set(state.settings, 'bootstrap_custom_segment_available', isActivated === 'YES')
    },

    setAccountIsEstimationFeatureAvailable(state, { isActivated }) {
        Vue.set(state.settings, 'rule_estimation_activated', isActivated === 'YES')
    },

    setAccountIsWamFactoActivated(state, { isActivated }) {
        Vue.set(state.settings, 'wam_factory_activated', isActivated === 'YES')
    },

    setWamFactoryRuleVersion(state, { version }) {
        Vue.set(state.settings, 'wamfactory_rules_version', version)
    },

    setAccountIsWamFactoLogsActivated(state, { isActivated }) {
        Vue.set(state.settings, 'wamfactory_logs_activated', isActivated === 'YES')
    },

    setAccountAllocationDashboardActivated(state, isActivated) {
        Vue.set(state.settings, 'allocationDashboardActivated', isActivated === 'YES')
    },

    setAccountXDeviceInfo(state, { xDeviceInfo }) {
        Vue.set(state, 'xDeviceInfo', xDeviceInfo)
    },

    setUserRole(state, { roles }) {
        let role = null
        if (includes(roles, 'webo_admin')) role = 'webo_admin'
        else if (includes(roles, 'webo_employee')) role = 'webo_employee'
        else if (includes(roles, 'webo_user')) role = 'webo_user'
        Vue.set(state, 'userRole', role)
    },

    setUserRights(state, { userRights }) {
        Vue.set(state, 'userRights', userRights)
    },

    setNamespaces(state, { namespaceList }) {
        const _namespaceList = []
        if (!isEmpty(namespaceList)) {
            for (const _namespace of namespaceList) {
                if (_namespace.status !== 'deleted') {
                    _namespaceList.push({
                        id: _namespace.id,
                        label: _namespace.namespace,
                        type: _namespace.namespace_type,
                        status: _namespace.status,
                        pattern: JSON.parse(_namespace.pattern).join(',')
                    })
                }
            }
        }
        Vue.set(state, 'namespaces', _namespaceList)
    },

    setNamespace(state, { namespace }) {
        const _namespaceList = state.namespaces
        _namespaceList.push({
            id: namespace.id,
            label: namespace.namespace,
            type: namespace.namespace_type,
            status: namespace.status,
            pattern: JSON.parse(namespace.pattern).join(',')
        })

        Vue.set(state, 'namespaces', _namespaceList.sort((a, b) => b.id - a.id))
    },

    setUpdatedNamespace(state, { namespace }) {
        const _namespaceList = state.namespaces
        const _namespace = {
            id: namespace.id,
            label: namespace.namespace,
            type: namespace.namespace_type,
            status: namespace.status,
            pattern: JSON.parse(namespace.pattern).join(',')
        }
        const _elemIndex = findIndex(_namespaceList, item => item.id === _namespace.id)
        _namespaceList.splice(_elemIndex, 1, _namespace)

        Vue.set(state, 'namespaces', _namespaceList)
    },

    unsetNamespace(state, { namespace }) {
        const _newList = filter(state.namespaces, item => item.id !== namespace.id)
        Vue.set(state, 'namespaces', _newList)
    },

    setDefaultNamespaceId(state) {
        const _defaultNamespace = find(state.namespaces, item => item.type === 'NAV')
        if (_defaultNamespace) {
            Vue.set(state, 'defaultNamespaceId', _defaultNamespace.id)
        }
    },

    setAttributionCounterAudience(state, { counter }) {
        Vue.set(state, 'attributionCounterAudience', counter)
    },

    setAttributionCounterTransfer(state, { counter }) {
        Vue.set(state, 'attributionCounterTransfer', counter)
    },

    setDailyBootstrapLimit(state, { limit }) {
        Vue.set(state, 'dailyBootstrapLimit', limit)
    },

    setDailyPushOfStockLimit(state, { limit }) {
        Vue.set(state, 'dailyPushOfStockLimit', limit)
    },

    setCustomer(state, customer) {
        state.customer = customer
    },
}

export default { ...commonMutations, ...mutations }
